import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.

/* eslint-disable react/prefer-stateless-function */
import React, { cloneElement, Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import FormField from '../FormField';
import Hint from '../Hint';
import Radio from '../Radio';

/**
 * `FormFieldRadioButtons` is used for making a choice among a set of mutually exclusive, related options. Only one option can be chosen.
 * @since 0.2.0
 */
var FormFieldRadioButtons =
/*#__PURE__*/
function (_Component) {
  _inherits(FormFieldRadioButtons, _Component);

  function FormFieldRadioButtons() {
    _classCallCheck(this, FormFieldRadioButtons);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormFieldRadioButtons).apply(this, arguments));
  }

  _createClass(FormFieldRadioButtons, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          baseClassName = _this$props.baseClassName,
          className = _this$props.className,
          options = _this$props.options,
          autoFocus = _this$props.autoFocus,
          multi = _this$props.multi,
          props = _objectWithoutProperties(_this$props, ["baseClassName", "className", "options", "autoFocus", "multi"]);

      return React.createElement(FormField, _extends({
        className: classNames(baseClassName, className)
      }, props), function (_ref) {
        var getId = _ref.getId,
            getName = _ref.getName,
            getValue = _ref.getValue,
            setValue = _ref.setValue,
            isDisabled = _ref.isDisabled;
        return options.map(function (_ref2, index) {
          var value = _ref2.value,
              label = _ref2.label,
              description = _ref2.description,
              disabled = _ref2.disabled,
              _ref2$indentFields = _ref2.indentFields,
              indentFields = _ref2$indentFields === void 0 ? [] : _ref2$indentFields;
          return React.createElement("div", {
            className: "".concat(baseClassName, "__radio"),
            key: value
          }, React.createElement(Radio, {
            name: getName(),
            checked: getValue() === value,
            onChange: function onChange(isChecked) {
              if (isChecked) {
                setValue(value);
              }
            },
            disabled: isDisabled() || disabled,
            inputProps: {
              id: getId() ? "".concat(getId(), "-").concat(value) : null,
              name: getName(),
              value: value,
              autoFocus: index === 0 && autoFocus ? true : undefined
            }
          }, label || value), description || indentFields ? React.createElement("div", {
            className: "".concat(baseClassName, "__content")
          }, description && React.createElement(Hint, {
            className: "".concat(FormField.defaultProps.baseClassName, "__description")
          }, description), indentFields.map(function (field) {
            if (isDisabled() || disabled || getValue() !== value) {
              return cloneElement(field, {
                disabled: true
              });
            }

            return field;
          })) : null);
        });
      });
    }
  }]);

  return FormFieldRadioButtons;
}(Component);

FormFieldRadioButtons.propTypes = {
  /**
   * Options definition.
   * @since 0.2.0
   */
  options: PropTypes.arrayOf(PropTypes.shape({
    /**
     * Option value.
     */
    value: PropTypes.string.isRequired,

    /**
     * Option label.
     */
    label: PropTypes.node.isRequired,

    /**
     * Text hint located below option for providing additional information.
     */
    description: PropTypes.node,

    /**
     * Set true if option is not available to choice.
     */
    disabled: PropTypes.bool,

    /**
     * Optional array of `FormField` components under this option.
     */
    indentFields: PropTypes.array
  })).isRequired,

  /**
   * Value of current chosen option.
   * @since 0.2.0
   */
  value: PropTypes.string.isRequired,

  /**
   * Disabled state of field.
   * @since 0.2.0
   */
  disabled: PropTypes.bool,

  /**
   * The browser will automatically focus on the component upon rendering the screen
   * @since 1.9.0
   */
  autoFocus: PropTypes.bool,

  /**
   * @ignore Field cannot be multiple
   */
  multi: PropTypes.bool,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  baseClassName: PropTypes.string
};
FormFieldRadioButtons.defaultProps = {
  disabled: undefined,
  autoFocus: undefined,
  multi: undefined,
  className: undefined,
  baseClassName: "".concat(CLS_PREFIX, "form-field-radio-buttons")
};
export default FormFieldRadioButtons;